import { Table } from 'antd';
import styled from 'styled-components';

export const AntTable = styled(Table)`
  min-height: calc(90vh - 100px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  transition: box-shadow 0.3s ease-in-out;
  background-color: #fff;
  table {
    width: auto !important;
  }
  .ant-table {
    .ant-table-row {
      height: 40px;
    }
  }

  &:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.2); /* Adjust box-shadow on hover */
  }

  .ant-table-thead .ant-table-cell {
    background-color: var(--bg-table-header-ash-color) !important;
    color: #fff;
  }
  .ant-table-thead {
    white-space: nowrap;
  }
  tbody {
    tr:nth-child(even) {
      background-color: var(--white-color); /* Set the background color for even rows */
    }

    tr:nth-child(odd) {
      background-color: var(--bg-table-body-lightAsh-color); /* Set the background color for odd rows */
    }
  }
  //adjust height of the row
  .ant-table-tbody > tr > td {
    padding: 3px 10px;
  }
  .ant-table-column-sort {
    background-color: inherit !important;
  }
  /* to remove the line inbetween the table heading */
  .ant-table-cell::before {
    content: unset !important;
  }
  .ant-table-content {
    border-radius: 8px;
  }
  .ant-table {
    border-radius: 8px;
  }
  &.modal-table {
    min-height: auto;
  }
  .ant-table-cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;
  }
`;
